import { createStore, applyMiddleware, compose } from "redux";
import fetchPromise from "./middlewares/fetchPromise";
import thunk from "redux-thunk";
import rootReducer from "./reducers";

let store;

const configureStore = preloadedState => {
  store = createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(fetchPromise, thunk),
    ),
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("./reducers", () => {
      store.replaceReducer(rootReducer);
    });
  }

  return store;
};

export { store };

export default configureStore;
